// Getters
export const GET_PLAYER_STATE               = 'gameState/GET_PLAYER_STATE';
export const GET_UI_BLOCK_GAMEPLAY_MAP      = 'gameState/GET_UI_BLOCK_GAMEPLAY_MAP';

export const GET_APP_STATE                  = 'appState/GET_APP_STATE';

export const GET_USER                       = 'auth/GET_USER';

// Mutations
export const REGISTER_BLOCK_GAMEPLAY_UI     = 'gameState/REGISTER_BLOCK_GAMEPLAY_UI';
export const UNREGISTER_BLOCK_GAMEPLAY_UI   = 'gameState/UNREGISTER_BLOCK_GAMEPLAY_UI';

export const SET_APP_STATE      = 'appState/SET_APP_STATE';

export const SET_LOGGED_IN      = 'auth/SET_LOGGED_IN';
export const SET_USER_DATA      = 'auth/SET_USER_DATA';
export const SET_PLAYER_DATA    = 'auth/SET_PLAYER_DATA';

// Actions
export const FETCH_USER_ASYNC             = 'auth/FETCH_USER_ASYNC';
export const FETCH_PLAYER_DATA_ASYNC      = 'auth/FETCH_PLAYER_DATA_ASYNC';
export const CREATE_PLAYER_DATA_ASYNC     = 'auth/CREATE_PLAYER_DATA_ASYNC';
export const UPDATE_PLAYER_DATA_ASYNC     = 'auth/UPDATE_PLAYER_DATA_ASYNC';